// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { articuloFragment } from '../../../base/fragments/articuloFragment.ts'
import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { ArticuloApiInputProps, ArticuloProps } from '../../../interfaces/articulo.ts'

const query = gql`
  ${articuloFragment}
  mutation articuloActualizar($cds: Int!, $codigoArticulo: String!, $input: ArticuloInput!) {
    articuloActualizar(cds: $cds, codigoArticulo: $codigoArticulo, input: $input) {
      ...ArticuloFields
    }
  }
`

/**
 * Actualizamos los datos de un articulo
 * @param cds
 * @param codigoArticulo
 * @param input
 */
export const apiArticuloActualizar = async (
  codigoArticulo: string,
  input: ArticuloApiInputProps,
): Promise<ArticuloProps> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)
    const cds = 1

    const data: any = await client.request(query, { cds, codigoArticulo, input })
    return data.articuloActualizar
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
